<template>
  <section id="benefits" class="py-24 bg-gray-50">
    <div class="max-w-6xl mx-auto text-center px-6">
      
      <!-- Benefícios do Google Ads e Gestão Profissional -->
      <h3 class="text-3xl font-bold text-gray-900 text-center">🚀 Benefícios do Google Ads e da Gestão Profissional</h3>
      <p class="text-lg text-gray-600 text-center mt-4 mb-10">
        Entenda como uma estratégia bem executada pode transformar seu negócio.
      </p>

      <div class="grid md:grid-cols-2 gap-10">
        <!-- Benefícios do Google Ads -->
        <div class="bg-white p-6 rounded-lg shadow-lg border border-gray-200 text-left" data-aos="fade-up">
          <h4 class="text-2xl font-semibold text-blue-600">🎯 Por que investir no Google Ads?</h4>
          <ul class="mt-4 space-y-2 text-gray-600">
            <li>✔ Alcance clientes no momento exato da busca.</li>
            <li>✔ Geração de leads qualificados para seu negócio.</li>
            <li>✔ Resultados rápidos e previsíveis.</li>
            <li>✔ Orçamento flexível: invista conforme seu crescimento.</li>
            <li>✔ Mensuração detalhada de desempenho.</li>
          </ul>
        </div>

        <!-- Importância da Gestão Profissional -->
        <div class="bg-white p-6 rounded-lg shadow-lg border border-gray-200 text-left" data-aos="fade-up" data-aos-delay="200">
          <h4 class="text-2xl font-semibold text-blue-600">📊 Vantagens da Gestão Profissional</h4>
          <ul class="mt-4 space-y-2 text-gray-600">
            <li>✔ Estratégias personalizadas para cada nicho.</li>
            <li>✔ Análises e otimizações constantes para máximo ROI.</li>
            <li>✔ Redução de desperdício de verba.</li>
            <li>✔ Campanhas alinhadas com os objetivos do seu negócio.</li>
            <li>✔ Suporte e ajustes conforme a performance.</li>
          </ul>
        </div>
      </div>

      <!-- Campanhas e Públicos Alvo -->
      <div class="mt-16 bg-blue-600 text-white p-10 rounded-lg shadow-lg" data-aos="fade-up">
        <h4 class="text-2xl font-semibold">🔎 Tipos de Campanhas e Públicos Potenciais</h4>
        <p class="mt-4 text-lg">
          A segmentação é essencial para o sucesso de uma campanha. Veja os principais tipos de campanhas e públicos que podemos atingir:
        </p>
        <div class="grid md:grid-cols-2 gap-6 mt-6 text-left">
          <div>
            <h5 class="text-lg font-bold">📢 Campanhas:</h5>
            <ul class="mt-2 space-y-2">
              <li>✅ Rede de Pesquisa (Google Search)</li>
              <li>✅ Rede de Display (Banners em sites parceiros)</li>
              <li>✅ YouTube Ads</li>
              <li>✅ Google Shopping</li>
              <li>✅ Remarketing</li>
            </ul>
          </div>
          <div>
            <h5 class="text-lg font-bold">👥 Públicos Alvo:</h5>
            <ul class="mt-2 space-y-2">
              <li>✅ Pessoas buscando seu produto ou serviço</li>
              <li>✅ Usuários que já visitaram seu site</li>
              <li>✅ Consumidores interessados no seu nicho</li>
              <li>✅ Potenciais clientes com base em comportamentos online</li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script setup>
import { onMounted } from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

onMounted(() => {
  AOS.init({ duration: 800, once: true });
});
</script>
